import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components'
import Rating from '@material-ui/lab/Rating';
import Box from '@material-ui/core/Box';
import Button from 'web/components/Button';
import DropDown from 'web/components/DropDown';
import FilterIcon from "web/assets/images/filterIcon.png";
// import card1 from 'web/assets/images/pallet-home-image.webp';
import card1 from 'web/assets/images/pallet-home-image.jpg';
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import RightArrowLight from "web/assets/images/right-arrow-sell.png";
import MembershipPlans from 'web/components/MembershipPlans';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import SearchTypeahead from "web/components/SearchTypeahead";
import GuestUserAdvanceSearch from "web/components/GuestUserAdvanceSearch";
import styles from './featured.module.scss';
import { fetchLanguageContentNew } from 'redux/actions/language';

const Featured = ({ totalRecord, pageType, response, title, currentPage, tabType, onChangeHandler, advanceSearchCallBack,searchCallBack }) => {
  const dispatch = useDispatch();
  const fileUrl = process.env.REACT_APP_API_URL + '/user/image/';
  const [searchDropDownSorting, setSearchDropDownSorting] = useState('DESC');

  let defaulTitle = localStorage.getItem("titleInput");

  const [getDefaulTitle, setDefaulTitle] = useState(defaulTitle);

  const [setTimer, setTimerState] = useState(false);
  const [clearFilterFlag, setClearFilterFlag] = useState(false);
  
  const typeahead = useRef(null);

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()
  const [dropDownArr, setDropDownArr] = useState([])
  const [filterArr, setFilterArr] = useState()

  const [membershipModal, setMembershipModal] = useState(false);
  const membershipToggleModal = () => setMembershipModal(!membershipModal);

  const [advanceModal, setAdvanceModal] = useState(false);
  const advanceModalToggleModal = () => setAdvanceModal(!advanceModal);

  useEffect(() => {
    if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  useEffect(() => {
    setDropDownArr([
      {
        id: '0',
        label: 'Oldest',
        value: 'ASC',
      },
      {
        id: '1',
        label:'Newest',
        value: 'DESC',
      },
    ])
  }, [pageLanguageContents])

  const onClickHandler = (e, index) => {
    membershipToggleModal();

  }

  useEffect(() => {
    setTimeout(
      () => {
        if (response.length === 0)
          setTimerState(true)
      },
      3000
    );
  })
  let selectedPage = tabType
  if (!selectedPage) {
    selectedPage = pageType
  }
  if (pageType === "PostInventory") {
    selectedPage = "Pallet Offers"
  } else if (pageType === "PostLoad") {
    selectedPage = "Pallet Needs"
  }

  const arrowSign = () => {
    return pageType === "PostLoad" ? (
      <img src={RightArrow} alt="RightArrow" className={styles.rightArrow} />
    ) : (
        <img
          src={RightArrowLight}
          alt="RightArrow"
          className={styles.rightArrow}
        />
      );
  }

  const sizeAttach=(value)=>{

    let size = value?.palletDetail?.size
    if(value?.palletDetail?.size === "31.5x47.2(1.2mx0.8m)"){
      size="31.5x47.2"
    }
    if(value?.palletDetail?.size === "47.2x39.4(1.2mx1.0m)"){
      size="47.2x39.4"
    }

    return <>
      {value?.palletDetail?.grade ?
          <>{value?.palletDetail?.grade}</>:
          value?.palletDetail?.size && value?.palletDetail?.size !== "Custom"?<>{size}</>:
          value?.palletDetail?.dimension?.length ?
          <>{`${value.palletDetail?.dimension.length} x ${value.palletDetail?.dimension.width} x ${value.palletDetail?.dimension.height}`}</>:<>{"NA"}</>
      }
    </>
  }
  return (
    <div className={styles.featuredSection}>
      <DropdownContainer>
        <div className={styles.dropDown}>        

            <SearchWraper>
              <SearchSection className='topbar-hide-mobile'>
                <SearchTypeahead
                  placeholder="Search by state, size, grade, etc."
                  focusOnShow={false}
                  typeahead={typeahead}
                  filterBy="title"
                  defaulTitle={getDefaulTitle}
                  title={title}
                  pageType="PostInventory"
                  pageName="Landing"
                  containerStyle="makeSearch"
                  color="#fff"
                  sortBy={searchDropDownSorting}
                  callBack={(val)=>{                  
                    searchCallBack(val)
                  }}
                />

{/* <             SearchSection className='topbar-hide-mobile'>      */}
                {/* {filterArr && <>
                  <p style={{display:"inline-flex",marginLeft:"10px", whiteSpace: "nowrap"}}>
                    {Object.values(filterArr).join(', ')}                 
                    <div style={{marginLeft:"10px", cursor:"pointer"}} onClick={()=>{
                      setFilterArr()
                      setClearFilterFlag(true)
                      advanceSearchCallBack()
                    }}>
                      <img src={CloseIcon} className="closeIcon" alt="close-icon" />
                    </div>
                  </p> 
                  
                </>} */}
              {/* </SearchSection> */}
              </SearchSection>

              
              {/* <AdvanceSearchDiv className='topbar-hide-mobile'
                onClick={() => advanceModalToggleModal()}
              >
                Advanced Search
              </AdvanceSearchDiv> */}
             
               {/* <ClearFilter className='topbar-hide-mobile'
                onClick={() => {
                  setClearFilterFlag(true)
                  advanceSearchCallBack()
                }}
              >
                Clear Filters
              </ClearFilter> */}              
            </SearchWraper>
            {/* <SearchSection className='topbar-hide-mobile'> */}
            <FilterWrapper>
                  <img
                    src={FilterIcon}
                    alt=""
                    onClick={() =>{
                      setDefaulTitle('')
                      advanceModalToggleModal(true)}
                    } 
                  />
            </FilterWrapper>

              {filterArr && <>
                <p style={{display:"inline-flex",marginLeft:"10px", whiteSpace: "nowrap"}}>
                  {Object.values(filterArr).join(', ')}                 
                  <div style={{marginLeft:"10px", cursor:"pointer"}} onClick={()=>{
                    setFilterArr()
                    setClearFilterFlag(true)
                    advanceSearchCallBack()
                  }}>
                    <img src={CloseIcon} className="closeIcon" alt="close-icon" />
                  </div>
                </p> 
                
              </>} 
           
             
            {/* </SearchSection> */}
          {totalRecord !== 0 && totalRecord !== "" ? (
            <>
              {totalRecord <= currentPage * 20 ? (
                <>
                  {totalRecord >= 20 ? (
                    <h6>
                      Showing{" "}
                      {currentPage === 1 ? 1 : <>{(currentPage - 1) * 20+parseInt(1)} </>}{" "}
                      -{totalRecord} out of {totalRecord}
                    </h6>
                  ) : (
                      <h6>
                        Showing 1-{totalRecord} out of {totalRecord}
                      </h6>
                    )}
                </>
              ) : (
                  <>
                    {totalRecord >= 20 ? (
                      <h6>
                        {pageLanguageContents?.HeaderContents[6]?.Showing}{" "}
                        {currentPage === 1 ? 1 : <>{(currentPage - 1) * 20+parseInt(1)} </>}-
                        {currentPage * 20} {pageLanguageContents?.HeaderContents[7]?.OutOf} {totalRecord}
                      </h6>
                    ) : (
                        <h6>
                          {pageLanguageContents?.HeaderContents[6]?.Showing} 1-{totalRecord} {pageLanguageContents?.HeaderContents[7]?.OutOf} {totalRecord}
                        </h6>
                      )}
                  </>
                )}
            </>
          ) : (
              <p></p>
            )}

           <ShortByWrapper>
           <p>Sort By:</p>
              <DropDown
                name="dropDown"
                data={dropDownArr}
                searchDropDown={searchDropDownSorting}
                placeholder={"Sort by inventory"}
                onChangeHandler={(event) => {
                  setSearchDropDownSorting(event.value);
                  onChangeHandler(event.value);
                }}
              />
           </ShortByWrapper>
        </div>
      </DropdownContainer>
    

      {response && response.length !== 0 ? (
        <>
          <div className={styles.imgSection}>
            {response.map((value, index) => (
              <div className={value.innerCircle ? styles.withYellowBorder : styles.normalBorder} onClick={(e) => onClickHandler(e, index)} key={index}>
                 <p className={styles.tag}>
                      {value.status === "BIDDING_CLOSE" ? (<>
                        {/* {arrowSign()} */}
                        <span className={styles.orange}>{pageLanguageContents?.TilesContents[1]?.Closed}</span>
                      </>
                      ) : (
                        <>
                          {value.private ? (<>
                            {/* {arrowSign()} */}
                            <span className={styles.orange}>
                              Private Post
                            </span>
                          </>
                          ) : (<>
                            {/* {arrowSign()} */}
                          </>
                          )}
                        </>
                        )}
                    </p>
                <div className={styles.img}>
                  <img alt="uploadImage" src={value.uploadImage && value.uploadImage.length > 0 ? `${fileUrl}${value.uploadImage[0]}` : card1} />
                </div>
                <div className={styles.textSection}>

                  {/* <p className={styles.itemName}>{value.title}</p> */}
                  <p className={styles.itemName}>
                    {/* Type:{" "} */}
                     <>{value.palletDetail?.commodity ? value.palletDetail?.commodity :
                        value.palletDetail?.material === 'PLASTIC' ? 'Plastic' :
                      'Custom'} - {sizeAttach(value)}</>
                  </p>
                  <p>Located in {value?.state}</p>
                  {/*  {value?.zipCode} */}
                  {value.pickup?<p> Must be Picked Up, {value?.quantity}  pallets</p>:<>
                    <p>Willing to Deliver, {value?.quantity}  pallets</p>
                    </>}
                  {/* <p className={styles.itemPrice}>
                                     
                  </p> */}

                  {/* <p className={styles.itemPrice}>
                     Qty:{" "}{value?.quantity}      
                  </p> */}
                  {/* <p className={styles.itemPrice}>
                    {pageLanguageContents?.TilesContents[10]?.Quantity}
                    {" "}{value.sellAll ? value.quantity / value.lots : value.quantity}
                    &nbsp;{value.sellAll && <LotsText>({value.lots} lot)</LotsText>}
                  </p> */}
                  {/* <div className={styles.rating}>
                    <RatingSection>
                      <span>{pageLanguageContents?.TilesContents[11]?.Rating}</span>{" "}
                      <Box
                        component="fieldset"
                        mb={3}
                        borderColor="transparent"
                      >
                        <Rating
                          name="simple-controlled"
                          value={5}
                          onChange={() => { }}
                        />
                      </Box>
                    </RatingSection>
                  </div> */}
                </div>
                <Button>{pageLanguageContents?.TilesContents[12]?.ViewProduct}</Button>
                <div className={styles.overlay}></div>
              </div>
            ))}
          </div>
        </>
      ) : (
          <div>
            <div className={styles.noFound}>
              {setTimer && <h6>No Record Found</h6>}
            </div>
          </div>
        )}

       <MembershipPlans
          isOpen={membershipModal}
          toggle={membershipToggleModal}
          memeberType=""

        />

      <GuestUserAdvanceSearch
            isOpen={advanceModal}
            toggle={advanceModalToggleModal}
            title=""
            onClickHander={(Obj) => { }}
            content=""
            link="/"
            clearFilter={clearFilterFlag}
            pageType="PostInventory"
            callBackFun={(val)=>{
              const obj={
                city:val.city,
                state:stateConvert(val.state),
                miles:val.mile,
                size:val.size,
                grade:val.grade
              }
              Object.keys(obj).forEach(key => {
                if (obj[key] === null || obj[key] === '' || obj[key] === undefined) {
                  delete obj[key];
                }
              });
              setClearFilterFlag(false)
              setFilterArr(obj)
              advanceSearchCallBack(val)
            }}
        />
    </div>
  );
}

export default Featured;

const RatingSection = styled.span`
    font-family: "latoregular";
    display: flex;
    gap: 10px;
    .MuiBox-root {
      margin-bottom: 0;
    }
`
const FilterWrapper = styled.div`
  margin-left: 10px;
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
  padding: 5px;
  border-radius: 10px;
  img {
    cursor: pointer;
  }
`;
const DropdownContainer = styled.div`
  .custom-select__control {
    border-radius: 23px;
    box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
    border: solid 1px #fff;
    background-color: #fff;
    height: 40px;
  }
`;
const LotsText = styled.small`
  line-height: 24px;
  color: #FF7F00;
  font-family: "latosemibold";

  @media (max-width: 767px) {
    font-size: 11px;
  }
`;
const SearchWraper = styled.div`
  max-width: 1430px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  flex: 1;
  padding: 5px 0 5px 29px;
  gap: 10px;
  position: relative;
  z-index: 1;
  .custom-select__control {
    height: 35px;
    min-height: 35px;
    border-radius: 2px;
  }
  @media (max-width: 1250px) {
    padding: 5px 0;
  }
  @media (max-width: 718px) {
    display: grid;
    grid-gap: 10px;
    /* .topbar-hide-mobile{
      display:none;
    } */
  }
`;

const SearchSection = styled.div`
  width: 100%;
  text-align:right;
  position: relative;
  z-index: 0;
  display: inline-flex;
  color: #0a5587;

  .type-ahead-search-input {
    display: flex;
    width: 100%;
    > div input {
      height: 37px;
      width: 100%;
      display: inline-flex;
      border-radius: 5px;
      margin-top: 5px;
      border: solid 1px #87cdf1;
    }
    .dropdown-menu .dropdown-item {
      padding: 10px 16px;
      font-size: 14px;
    }
    p{
      width: 100%;
      display: inline-flex;
    }
    .seacrh-icon {
      margin: 0;
      height: 35px;
      position: absolute;
      cursor: pointer;
      right: 0;
    }
  }
  @media (max-width: 1250px) {
    max-width: 100%;
    min-width: 305px;
  }
  @media (max-width: 718px) {
    padding: 0;
  }
`;
const AdvanceSearchDiv = styled.div`
  border-radius: 5px;
  background: #61b01f;
  background: -moz-linear-gradient(top, #61b01f 0%, #27911b 100%);
  background: -webkit-linear-gradient(top, #61b01f 0%, #27911b 100%);
  background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#61b01f', endColorstr='#27911b',GradientType=0 );
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  min-width: 161px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 37px;
  cursor: pointer;
  font-family: "latobold";
  @media (max-width: 718px) {
    text-align: center;
  }
`;
const ClearFilter = styled.div`
  border-radius: 5px;
  /* background: #61b01f; */
  /* background: -moz-linear-gradient(top, #61b01f 0%, #27911b 100%);
  background: -webkit-linear-gradient(top, #61b01f 0%, #27911b 100%);
  background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#61b01f', endColorstr='#27911b',GradientType=0 ); */
  color: #0a5587;
  font-size: 16px;
  text-decoration: underline;
  min-width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 37px;
  cursor: pointer;
  font-family: "latobold";
  @media (max-width: 718px) {
    text-align: center;
  }
`;


const ShortByWrapper = styled.div`
display: grid;
grid-template-columns: auto 1fr;
gap: 10px;
> div {
  width: 200px;
}
`